import { Fragment, type ReactNode } from "react";

interface TProps {
  children: ReactNode;
  condition: boolean;
}

const RenderIf = function (props: TProps) {
  const { condition, children } = props;

  if (!condition) {
    return null;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <Fragment>{children}</Fragment>;
};

export default RenderIf;
